import * as Types from '../constants/actionTypes';

let defaultProgramState = {
  programStoreData: {},
  programProcessPartnerList: [],
  programProcessPartnerFilter: [],
  programCarrierList: [],
  programDocTypeList: [],
  programs: [],
  allStores: [],
  portalUserList: [],
  portalUserPaginationKeys: [],
  addedProgramCountry: {},
  programLabelsList: [],
  portalUserLogs: [],
  programAssets: [],
  programAdditionalInfo: [],
  programCountiesList: [],
  recyclingPartners: [],
  programData: [],
  portalAdditionalFields: [],
  questionsList: [],
  allProgramsCountryList: [],
  selectedProgramData: {},
  qrcodes: [],
  portalModuleLogs: [],
  portalContactList:[],
  companyContactList: [],
  programCompanyList: [],
  paginationProgramCompanyList: [],
  isProgramAdding: false,
  programMessage: null,
  programError: null
}
export default (state = defaultProgramState, action) => {
  switch (action.type) {
    /* Program Details Information */
    case Types.SET_PROGRAM_CLIENTID: {
      return {
        ...state,
        programClientId: action.programClientId
      }
    }
    case Types.UPDATE_PROGRAM_DETAILS: {
      return {
        ...state,
        programDetails: action.programDetails
      }
    }
    case Types.PROGRAM_DETAILS_ERROR: {
      return {
        ...state,
        programDetailError: action.programDetailError
      }
    }

    /* Portal Logo Information */
    case Types.SET_PORTAL_LOGO_NAME: {
      return {
        ...state,
        selectedPortalLogoName: action.selectedPortalLogoName
      }
    }
    case Types.SET_PORTAL_LOGO: {
      return {
        ...state,
        selectedPortalLogo: action.selectedPortalLogo
      }
    }

    case Types.SET_PROGRAM_COUNTRYID: {
      return {
        ...state,
        programCountryId: action.programCountryId
      }
    }
    case Types.LIST_PROGRAM_COUNTRIES: {
      return {
        ...state,
        programCountries: action.programCountries
      }
    }
    case Types.PROGRAM_COUNTRY_INFO_COUNT:
      return Object.assign({}, state, { programCountryInfoCount: action.programCountryInfo })
    case Types.SELECTED_PROGRAM_DATA: {
      return {
        ...state,
        selectedProgramData: action.selectedProgramData
      }
    }
    case Types.PROGRAMS_DATA: {
      return {
        ...state,
        programs: action.programs
      }
    }
    case Types.LIST_PACKAGING_LIST_ON_PROGRAMS: {
      return {
        ...state,
        packagingList: action.packagingList
      }
    }
    case Types.LIST_PROGRAM_PACKAGING_LIST: {
      return {
        ...state,
        programPackingList: action.programPackingList
      }
    }
    case Types.LIST_PROGRAM_PACKAGING_GRADE_LIST: {
      return {
        ...state,
        programPackingGradeList: action.programPackingGradeList
      }
    }

    case Types.ADD_PROGRAM_PACKAGING_LIST:
      state.programPackingList.push(action.programPackingListItem)
      return {
        ...state
      }
      case Types.DELETE_PROGRAM_PACKAGING_LIST:
        //state.programPackingList.splice(action.pIndex, 1);
        return {
          ...state,
          programPackingList: action.programPackingList
        }
    case Types.PROGRAM_PACKAING_ERROR:
      return {
        ...state,
        packagingError: action.packagingError
      }
    case Types.PROGRAM_PACKING_INFO_COUNT:
      return Object.assign({}, state, { programPackingCount: action.programPackingInfo })
    case Types.PROGRAM_PACKING_GRADE_INFO_COUNT:
      return Object.assign({}, state, { programPackingGradeCount: action.programPackingGradeInfo })


    case Types.PROGRAM_PROCESSING_PARTNERS_LIST:
      return {
        ...state,
        programProcessPartnerList: action.programProcessPartnerList
      }
    case Types.PROGRAM_PROCESSING_PARTNERS_FILTER:
      return {
        ...state,
        programProcessPartnerFilter: action.programProcessPartnerFilter
      }
    case Types.PROGRAM_PROCESSING_PARNTER_ADD:
      // const selectedIndex = state.programProcessPartnerList.findIndex((oneData) => { return oneData.countryId === action.newProgramProcess.id })
      // if (selectedIndex >= 0) {
      //   state.programProcessPartnerList.splice(selectedIndex, 0, action.newProgramProcess)
      // }
      state.programProcessPartnerList.push(action.newProgramProcess)
      return {
        ...state
      }
    case Types.UPDATE_PROGRAM_PROCESSING_PARTNER:
      let prgIndex = state.programProcessPartnerList.findIndex((x) => x.id === action.updatedProgramProcessingPartner.id)
      if (prgIndex > -1) {
        const finalPayload = action.updatedProgramProcessingPartner
        if (state.programProcessPartnerList[prgIndex].countryInfo) {
          finalPayload.countryInfo = state.programProcessPartnerList[prgIndex].countryInfo
        }
        state.programProcessPartnerList[prgIndex] = finalPayload
      }
      return {
        ...state
      }
    case Types.PROGRAM_PROCESSING_PARNTER_ERROR:
      return {
        ...state,
        programPartnerError: action.programPartnerError
      }
    case Types.ALL_PROGRAM_PROCESSING_PARTNER_ERROR:
      return {
        ...state,
        allProgramPartnerError: action.allProgramPartnerError
      }
    case Types.DELETE_PROGRAM_PROCESSING_PARTNER:
      const existProcessingPartner = state.programProcessPartnerList
      existProcessingPartner.splice(action.deletedIndex, 1);
      return {
        ...state,
        programProcessPartnerList: existProcessingPartner
      }
    case Types.PROGRAM_PROCESSING_PARTNER_INFO_COUNT:
      return Object.assign({}, state, { programProcessingPartnerCount: action.programProcessingPartnerInfo })
    /* Program Carriers Reducers */
    case Types.PROGRAM_CARRIER_LIST:
      return {
        ...state,
        programCarrierList: action.programCarrierList
      }
    case Types.PROGRAM_ALL_CARRIER_LIST:
      return {
        ...state,
        programAllCarrierList: action.programAllCarrierList
      }
    case Types.PROGRAM_CARRIER_ERROR:
      return {
        ...state,
        programCarrierError: action.programCarrierError
      }
    case Types.ADD_PROGRAM_CARRIER_DATA:
      state.programCarrierList.push(action.addProgramCarrierData)
      return { ...state };

    case Types.DELETE_PROGRAM_CARRIER:
      state.programCarrierList.splice(action.deletedIndex, 1);
      return state
    case Types.PROGRAM_CARRIER_INFO_COUNT:
      return Object.assign({}, state, { programCarrierCount: action.programCarrierInfo })

    /* Program Brands Reducers */
    case Types.PROGRAM_BRANDS_LIST_SUCCESS:
      return {
        ...state,
        programBrandsList: action.programBrandsList
      }

    case Types.GET_ALL_PROGRAM_BRANDS_SUCCESS:
      return {
        ...state,
        allProgramBrands: action.allProgramBrands
      }

    case Types.PROGRAM_BRANDS_LIST_COUNT:
      return Object.assign({}, state, { programBrandsCount: action.programBrandsCount })

    case Types.PROGRAM_BRANDS_ERROR:
      return {
        ...state,
        programBrandsError: action.programBrandsError
      }
    case Types.ADD_PROGRAM_BRAND_DATA:
      state.programBrandsList.push(action.addProgramBrandData)
      return { ...state };

    case Types.DELETE_PROGRAM_BRAND:
      return { ...state };

    /** Program Document Type Reducers */
    case Types.PROGRAM_DOC_TYPE_LIST:
      return {
        ...state,
        programDocTypeList: action.programDocTypeList
      }
    case Types.PROGRAM_DOC_TYPE_ERROR:
      return {
        ...state,
        programDocTypeError: action.programDocTypeError
      }
    case Types.PROGRAM_DOC_TYPE_ITEM:
      state.programDocTypeList[action.docIndex] = action.oneProgramDocTypeItem
      return {
        ...state
      }
    case Types.ADD_PROGRAM_DOC_TYPE_DATA:
      state.programDocTypeList.unshift(action.addedDocTypeData)
      return { ...state };

    case Types.DELETE_PROGRAM_DOCUMENT_TYPE:
      state.programDocTypeList.splice(action.deletedIndex, 1);
      return state
    case Types.PROGRAM_DOCUMENT_INFO_COUNT:
      return Object.assign({}, state, { programDocumentCount: action.programDocumentInfoCount })

    /* Program Boxes Reducers */
    case Types.PROGRAM_BOXES_DATA:
      return {
        ...state,
        programBoxesList: action.programBoxesList
      }
    case Types.PROGRAM_BOX_ADDED:
      state.programBoxesList.push(action.newProgramBox)
      return {
        ...state
      }
    case Types.PROGRAM_BOXES_ERROR:
      return {
        ...state,
        programBoxError: action.programBoxError
      }
    case Types.PROGRAM_BOX_DELETED:
      state.programBoxesList.splice(action.deletedBoxIndex, 1);
      return { ...state }
    case Types.PROGRAM_BOX_INFO_COUNT:
      return Object.assign({}, state, { programBoxCount: action.programBoxInfo })


    /* Program Label Reducers */
    case Types.PROGRAM_LABELS_DATA:
      return {
        ...state,
        programLabelsList: action.programLabelsList
      }
    case Types.PROGRAM_LABEL_ADDED:
      state.programLabelsList.push(action.newProgramLabel.data)
      return {
        ...state,
      }
    case Types.PROGRAM_LABELS_ERROR:
      return {
        ...state,
        programLabelError: action.programLabelError
      }
    case Types.PROGRAM_LABEL_DELETED:
      return {
        ...state,
        deleteStatus: action.deletedLabelIndex
      }
    case Types.PROGRAM_LABEL_INFO_COUNT:
      return Object.assign({}, state, { programLabelCount: action.programLabelInfo })


    /* Program Countries Reducers */
    case Types.PROGRAM_COUNTIRES_LIST:
      return {
        ...state,
        programCountiesList: action.programCountiesList
      }
    case Types.ON_ADD_PROGRAM_COUNTRY:
      state.programCountiesList.push(action.addedProgramCountry)
      return { ...state }
    case Types.UPDATED_PROGRAM_COUNTRY_DATA:
      const existProgramCountryList = state.programCountiesList;
      existProgramCountryList[action.pCountryIndex] = action.updatedProgramCountry

      return {
        ...state,
        programCountiesList: existProgramCountryList
      }

    case Types.DELETED_PROGRAM_COUNTRY:
      const existedProgramCountryData = state.programCountiesList
      existedProgramCountryData.splice(action.deletedPCountryIndex, 1);
      return {
        ...state,
        programCountiesList: existedProgramCountryData
      }



    case Types.ALL_PROGRAM_COUNTRIES_LIST:
      return {
        allProgramsCountryList: action.allProgramCountryData
      }

    case Types.ALL_PROGRAM_COUNTRIES_ERROR:
      return {
        allProgramCountryError: action.allProgramCountryError
      }
    case Types.PROGRAM_COUNTRIES_ERROR:
      return {
        ...state,
        programCountryError: action.programCountryError
      }

    case Types.PROGRAM_FEEDBACK_QUESTION_ERROR:
      return {
        ...state,
        programFeedbackQuestionError: action.programFeedbackQuestionError
      }
    case Types.PROGRAM_FEEDBACK_QUESTIONS_UPDATED_SUCCESS:
      state.questionsList[action.updateIndex] = action.payload
      return {
        ...state,
        updatedStatus: action.payload
      }

    /* Program Asset Reducers */
    case Types.PROGRAM_ASSETS_LIST:
      return {
        ...state,
        programAssets: action.programAssets
      }
    case Types.PROGRAM_ASSETS_LIST_WITH_DATA_BEARING:
      return {
        ...state,
        programAssetsWithDataBearing: action.programAssetsWithDataBearing
      }

    case Types.PROGRAM_PACKAGING_SERVICES:
      return {
        ...state,
        programPackingServices: action.programPackagingServices
      }


    case Types.ON_ADD_PROGRAM_ASSET:
      state.programAssets.push(action.addedProgramAsset)
      return {
        ...state
      }
    case Types.UPDATED_PROGRAM_ASSET:
      console.log(state.programAssets, 'programAssetsprogramAssets')
      const updateIndex = state.programAssets.findIndex((oneAsset) => { return oneAsset.id === action.updatedProgramAsset.id });
      if (updateIndex > -1) {
        state.programAssets[updateIndex] = action.updatedProgramAsset// const existAssetList = state.programAssets;
        // existAssetList[action.upIndex] = action.updatedProgramAsset
      }
      return {
        ...state,
        //updatedStatus: action.updatedProgramAsset
      }
    case Types.DELETED_PROGRAM_ASSET:
      const existedProgramAssets = state.programAssets
      existedProgramAssets.splice(action.deletedAssetIndex, 1)
      return {
        ...state,
        programAssets: existedProgramAssets
      }
    case Types.PROGRAM_ASSETS_ERROR:
      return {
        ...state,
        programAssetError: action.programAssetError
      }
    case Types.PROGRAM_ASSET_INFO_COUNT:
      return Object.assign({}, state, { programAssetInfoCount: action.programAssetInfo })
    case Types.GROUP_ID:
      return {
        ...state,
        groupId: action.data
      }
    case Types.GROUP_USER_DATA:
      return {
        ...state,
        groupData: action.data
      }


    case Types.LIST_PROGRAM_REQUEST_TYPES:
      return {
        ...state,
        programRequestTypesList: action.programRequestTypesList
      }
    case Types.REQUEST_TYPES_DATA:
      return {
        ...state,
        allRequestTypes: action.allRequestTypes
      }
    case Types.REQUEST_TYPES_ERROR:
      return {
        ...state,
        programRequestError: action.programRequestError
      }
    case Types.PROGRAM_REQUEST_INFO_COUNT:
      return Object.assign({}, state, { programRequestCount: action.programRequestInfoCount })


    /* Program Store Reducers  */
    case Types.ALL_STORE_LOCATIONS:
      return {
        ...state,
        allStores: action.allStores
      }
    case Types.STORE_ERROR:
      return {
        ...state,
        storeError: action.storeError
      }
    case Types.PORTAL_STORE_ERROR:
      return {
        ...state,
        portalStoreError: action.portalStoreError
      }
    case Types.SET_PORTAL_STORAGE:
      let storagePayload = {}
      if (state.programStoreData[Types.PORTAL_PREFIX + action.programId]) {
        storagePayload = { ...state.programStoreData[Types.PORTAL_PREFIX + action.programId] }
      }
      if (action.isRegion) {
        storagePayload["awsRegion"] = action.awsRegion
        state.programStoreData[Types.PORTAL_PREFIX + action.programId] = action.portalStorageData
      } else {
        storagePayload = { ...storagePayload, ...action.portalStorageData }
      }

      if (action.regionOnlyProvided) {
        storagePayload["regionOnlyProvided"] = true
      }
      let programStoreData = state.programStoreData
      programStoreData[Types.PORTAL_PREFIX + action.programId] = storagePayload
      state.programStoreData = programStoreData
      return {
        ...state
      }
    case Types.SET_PORTAL_STORAGE_CONFIRMED:
      const existPortalData = state.selectedProgramData
      existPortalData.isStoreProvided = true
      return {
        ...state,
        selectedProgramData: existPortalData
      }

    case Types.PORTAL_STORAGE_INFO:
      state.programStoreData[Types.PORTAL_PREFIX + action.programId] = action.portalStoreInfo
      const existPortalStorage = state.programStoreData
      existPortalStorage[Types.PORTAL_PREFIX + action.programId] = action.portalStoreInfo
      return {
        ...state,
        programStoreData: existPortalStorage
      }
    // Portal Users Reducers
    case Types.LIST_PORTAL_USER:
      return {
        ...state,
        portalUserList: action.portalUserList
      }
    case Types.PORTAL_USER_PAGE_LAST_EVALUATED_KEY: {
      let existKeys = state.portalUserPaginationKeys
      if (action.popClear) {

        if (existKeys && existKeys.length) {
          existKeys.pop()
        }
        if (action.isPrevious && existKeys.length > 1) {
          existKeys.pop()
        }
      }
      if (action.LastEvaluatedKey) {
        existKeys.push(action.LastEvaluatedKey)
      }
      return {
        ...state,
        portalUserPaginationKeys: existKeys
      }
    }
    case Types.PORTAL_USER_GROUP:
      return {
        ...state,
        portalUserGroupList: action.portalUserGroupList
      }
    case Types.DELETE_PORTAL_USER:
      if (action.username) {
        const userIndex = state.portalUserList.findIndex((oneData) => { return (oneData.username === action.username) })
        if (userIndex > -1) {
          state.portalUserList.splice(userIndex, 1)
        }
      }
      return {
        ...state
      }
    // Portal User Reducer
    case Types.PORTAL_ONE_USER_INFO:
      return {
        ...state,
        onePortalUserInfo: action.onePortalData
      }
    // case Types.PORTAL_STORAGE_INFO:
    //   return {
    //     ...state
    //   }
    case Types.PORTAL_USER_ADDED:
      state.portalUserList.push(action.addedNewPortal)
      state.onePortalUserInfo = action.addedNewPortal
      return {
        ...state
      }

    case Types.PORTAL_USER_UPDATED:
      const onePortalUserList = state.portalUserList
      const updateItemIndex = onePortalUserList && onePortalUserList.findIndex((onePortal) => { return onePortal.userId === action.userId })
      if (updateItemIndex >= 0) {
        onePortalUserList[updateItemIndex] = action.updatedPortalUser
      }
      return {
        ...state,
        portalUserList: onePortalUserList
      }
    case Types.PORTAL_USER_ERROR:
      return {
        ...state,
        portalUserError: action.portalUserError
      }
    case Types.USER_FAILED :
        return {
          ...state,
          userDetailsError: action.errorMessage,
      }
    case Types.USER_SUCCESS:
        return {
          ...state,
          userDetails: action.data.data,
      }
    case Types.USER_DETAILS_BY_USER_ID:
        return {
          ...state,
            singleUserDetails: action.data,
      }
      case Types.USER_DETAILS:
        return {
          ...state,
          usersList: action.data.data,
        }
    case Types.PORTAL_USER_LOGS_INFO:
      return {
        ...state,
        portalUserLogs: action.userLogs
      }
    case Types.MODULE_LOGS_INFO:
      return {
        ...state,
        portalModuleLogs: action.userLogs
      }
    case Types.MODULE_LOGS_COUNT:
      return Object.assign({}, state, { countPortalModuleLogs: action.count })
    case Types.CHANGE_LOG_SETTINGS_SUCCESS:
      return {
        ...state,
        changeLogSetting: action.payload
      }
    case Types.GET_RECYLCLEPARTNER_LIST_TYPE_SUCCESS:
      return {
        ...state,
        recyclingPartners: action.payload
      }
    case Types.PROGRAM_DATA:
      return {
        ...state,
        programData: action.programData
      }
    case Types.PROGRAM_ADDING:
      return { ...state, isProgramAdding: true }
    case Types.PROGRAM_COPY_SUCCESS:
      return { ...state, programMessage: action.payload.message, isProgramAdding: false }
    case Types.CLEAR_PROGRAM_MESSAGE:
        return { ...state, programMessage: "", programError: "" }
    case Types.PROGRAM_ERROR:
      return { ...state, programError: action.payload.message }
    case Types.PORTAL_GROUP_DATA:
      return {
        ...state,
        portalGroups: action.portalGroups.data
      }
    case Types.PORTAL_GROUP_ADD_DATA:
      state.portalGroups.push(action.data)
      return {
        ...state,
      }
    case Types.PORTAL_GROUP_ERR:
      return {
        ...state,
        portalGroupsErr: action.portalGroupsErr
      }
    case Types.PORTAL_MODULE_DATA:
      return {
        ...state,
        portalModules: action.portalModules.data
      }
    case Types.PORTAL_MODULE_ERR:
      return {
        ...state,
        portalModuleErr: action.portalModuleErr
      }
    case Types.PORTAL_USER_GROUP_DATA:
      return {
        ...state,
        portalUserGroup: action.data
      }
    case Types.PORTAL_USER_GROUP_ERR:
      return {
        ...state,
        portalUserGroupErr: action.err
      }


    /*Portal Addition Fields */
    case Types.PORTAL_ADDITIONAL_FIELD_DATA:
      return {
        ...state,
        portalAdditionalFields: action.portalAdditionalFields
      }
    case Types.ADDED_PORTAL_ADDITIONAL_FIELD_DATA:
      state.portalAdditionalFields.push(action.addedAdditionalFields)
      return {
        ...state
      }
    case Types.UPDATED_PORTAL_ADDITIONAL_FIELD_DATA:
      if (action.updatedAdditionalFields) {
        const selectedIndex = state.portalAdditionalFields.findIndex((oneData) => oneData.id === action.updatedAdditionalFields.id)
        state.portalAdditionalFields[selectedIndex] = action.updatedAdditionalFields
      }
      return {
        ...state
      }
    case Types.DELETED_PORTAL_ADDITIONAL_FIELD_DATA:
      const deleteAddIndex = state.portalAdditionalFields.findIndex((oneData) => oneData.id === action.deleteId)
      if (deleteAddIndex >= 0) {
        state.portalAdditionalFields.splice(deleteAddIndex, 1)
      }
      return {
        ...state
      }
    case Types.PORTAL_ADDITIONAL_FIELD_ERROR:
      return {
        ...state,
        portalAddFieldsError: action.portalAddFieldsError
      }
    case Types.ADDITIONAL_FIELD_COUNT_SUCCESS:
      return Object.assign({}, state, { additionalFieldCount: action.payload })

    // User Groups functionalities


    case Types.REPORT_MODULE_DATA:
      return {
        ...state,
        reportModuleList: action.data,
      }

    case Types.REPORT_MODULE_ERR:
      return {
        ...state,
        reportModuleErr: action.err,
      }

    case Types.REPORT_MODULE_ADD:
      state.reportModuleList.push(action.data)
      return {
        ...state,
      }
    ///////////////////////////////////////////
    case Types.GROUP_DATA:
      return {
        ...state,
        groupList: action.data,
      }

    case Types.GROUP_ERR:
      return {
        ...state,
        groupErr: action.err,
      }

    case Types.GROUP_ADD:
      state.groupList.push(action.data)
      return {
        ...state,
      }
    case Types.UPDATE_PORTAL_GROUP:
      const selectedGroupIndex = state.groupList.find((oneGroup) => { return oneGroup.id === action.id })
      const existGroupList = state.groupList
      if (selectedGroupIndex >= 0) {
        existGroupList[selectedGroupIndex] = { ...existGroupList[selectedGroupIndex], ...action.payload }
        state.groupList = existGroupList
      }
      return { ...state }

    case Types.USER_GROUP:
      return {
        ...state,
        userGroup: action.data,
      }

    case Types.USER_GROUP_LOADING:
      return {
        ...state,
        loadingUserGroup: action.data,
      }

    case Types.USER_GROUP_ERR:
      return {
        ...state,
        userGroupErr: action.err,
      }
    ///////////////////////////////////////////
    case Types.REQ_TYPE_DATA:
      return {
        ...state,
        reqTypeList: action.data,
      }
    case Types.REQ_TYPE_ERR:
      return {
        ...state,
        reqTypeErr: action.err,
      }

    case Types.P_COUNTRY_DATA:
      return {
        ...state,
        countryList: action.data,
      }
    case Types.P_COUNTRY_ERR:
      return {
        ...state,
        countryErr: action.err,
      }

    case Types.SITE_DATA:
      return {
        ...state,
        siteList: action.data,
      }

    case Types.SITE_ERR:
      return {
        ...state,
        siteErr: action.err,
      }
    case Types.PROGRAM_ADDITIONAL_INFO_LIST:
      return {
        ...state,
        programAdditionalInfo: action.programAdditionalInfo
      }
    case Types.ON_ADD_PROGRAM_ADDITIONAL_INFO:
      state.programAdditionalInfo.push(action.addedProgramAdditionalInfo)
      return {
        ...state
      }
    case Types.ADD_PROGRAM_ADDITIONAL_INFO_COUNT:
      return Object.assign({}, state, { programAdditionalInfoCount: action.programAdditionalInfo })
    case Types.DELETED_PROGRAM_ADDITIONAL_INFO:
      const existedProgramdata = state.programAdditionalInfo
      existedProgramdata.splice(action.deletedIndex, 1)
      return {
        ...state,
        programAdditionalInfo: existedProgramdata
      }

    case Types.PROGRAM_REQUEST_TYPES_TOTAL_LIST:
      return {
        ...state,
        programRequestTypes: action.programRequestTypes
      }
    case Types.HOME_OFFICE_STORE_CONFIGURATION:
      return {
        ...state,
        isHomeConfiguration: action.data.isHomeStoreConfigured
      }
    case Types.UPLOAD_BULK_USERS:
      return {
        ...state,
        bulkUsersData: action.usersData
      }
    case Types.BULK_USERS_ERROR:
      return {
        ...state,
        bulkUserError: action.userError
      }


    // B2C Portal Reception
    case Types.TRACK_NO_DETAILS_SUCCESS:
      return {
        ...state,
        requestIdList: action.requestData
      }
    case Types.TRACK_NO_DETAILS_ERROR:
      return {
        ...state,
        requsetIdError: action.requestError
      }

    /*Portal QR Code */
    case Types.PORTAL_QRCODE_DATA:
      return {
        ...state,
        qrcodes: action.qrcodes
      }
    case Types.PORTAL_QRCODE_DATA_ADDED:
      state.qrcodes.push(action.data)
      return {
        ...state
      }
    case Types.PORTAL_QRCODE_DATA_UPDATED:
      if (action.data) {
        const idx = state.qrcodes.findIndex((d) => d.id === action.data.id)
        state.qrcodes[idx] = action.data
      }
      return {
        ...state
      }
    case Types.PORTAL_QRCODE_DATA_DELETED:
      const idx = state.qrcodes.findIndex((d) => d.id === action.id)
      if (idx >= 0) {
        state.qrcodes.splice(idx, 1)
      }
      return {
        ...state
      }
    case Types.PORTAL_QRCODE_ERROR:
      return {
        ...state,
        error: action.error
      }
    case Types.PORTAL_QRCODE_DATA_COUNT:
      return Object.assign({}, state, { qrcodesCount: { count: action.data } })
    /* Program Companies Reducers */
    case Types.PROGRAM_COMPANY_LIST:
      return {
        ...state,
        programCompanyList: action.programCompanyList
      }
    case Types.PAGINATION_PROGRAM_COMPANY_LIST:
      return {
        ...state,
        paginationProgramCompanyList: action.programCompanyList
    }
    case Types.PROGRAM_COMPANY_LIST_COUNT:
      return {
        ...state,
        programCompanyListCount: action.programCompanyListCount
    }
    case Types.PROGRAM_COMPANY_ERROR:
      return {
        ...state,
        programCompanyError: action.programCompanyError
      }
    // case Types.ADD_PROGRAM_COMPANY:
    //   return {
    //     ...state,
    //     paginationProgramCompanyList: [...state.paginationPortalContactList, action.addProgramCompany].sort((a, b) => a.name < b.name ? -1 : 1)
    //   }
    // case Types.UPDATE_PROGRAM_COMPANY: {
    //   const updateIndex = state.paginationProgramCompanyList.findIndex(company => company.id === action.updateProgramCompany.id);
    //   const newCompany = { ...state.paginationProgramCompanyList[updateIndex], ...action.updateProgramCompany };
    //   state.paginationPortalContactList.splice(updateIndex, 1, newCompany);

    //   return {
    //     ...state,
    //   }
    // }
    case Types.UPDATE_CONTACT_FROM_COMPANY:
      var { companyId, ...updatedContact } = action.payload;
      const updatedCompany = state.paginationProgramCompanyList.find(i => i.id === companyId);
      updatedCompany.contacts.splice(updatedCompany.contacts.findIndex(c => c.id === updatedContact.id), 1, updatedContact) 
      return {
        ...state,
      }
    case Types.PROGRAM_COMPANY_INFO_COUNT:
      return Object.assign({}, state, { programCompanyCount: action.programCompanyInfo })

    /* Program Languages Reducers */
    case Types.PROGRAM_LANGUAGES_LIST_SUCCESS:
      return {
        ...state,
        programLanguagesList: action.programLanguagesList
      }

    case Types.GET_ALL_PROGRAM_LANGUAGES_SUCCESS:
      return {
        ...state,
        allProgramLanguages: action.allProgramLanguages
      }

    case Types.PROGRAM_LANGUAGES_LIST_COUNT:
      return Object.assign({}, state, { programLanguagesCount: action.programLanguagesCount })

    case Types.PROGRAM_LANGUAGES_ERROR:
      return {
        ...state,
        programLanguagesError: action.programLanguagesError
      }
    case Types.ADD_PROGRAM_LANGUAGES_DATA:
      state.programLanguagesList.push(action.addProgramLanguagesData)
      return { ...state };

    case Types.DELETE_PROGRAM_LANGUAGE:
      return { ...state };
    default:
      return state;
  case Types.PORTAL_CONTACT_ERROR:
      return {
        ...state,
        portalContactError: action.portalContactError
      }
  case Types.PORTAL_CONTACT_LIST:
      return {
        ...state,
        portalContactList: action.portalContactList
    }
  case Types.PAGINATION_PORTAL_CONTACT_LIST:
    return {
      ...state,
      paginationPortalContactList: action.portalContactList
    }
  case Types.PORTAL_CONTACT_LIST_COUNT:
    return {
      ...state,
      PortalContactListCount: action.PortalContactListCount
    }
  case Types.ADD_PORTAL_CONTACT:
    return {
      ...state,
      addPortalContact: action.addPortalContact
    }

  case Types.COMPANY_CONTACT_ERROR:
      return {
        ...state,
        companyContactError: action.companyContactError
      }
  case Types.COMPANY_CONTACT_LIST:
      return {
        ...state,
        companyContactList: action.companyContactList
    }
  case Types.ADD_COMPANY_CONTACT:
    var { companies, ...addedContact } = action.addCompanyContact;
    companies.map(({ id }) => {
      const updatedCompany = state.paginationProgramCompanyList.find(i => i.id === id)
      if (updatedCompany)
        updatedCompany.contacts = updatedCompany.contacts.filter(c => c.id !== addedContact.id).concat(addedContact).sort((a, b) => a.name < b.name ? -1 : 1)
      return updatedCompany;
    })
    return {
      ...state,
    }
  case Types.DELETE_COMPANY_CONTACT:
    const updateCompany = state.paginationProgramCompanyList.find(company => company.id === action.payload.companyId);
    if (updateCompany) updateCompany.contacts = updateCompany.contacts.filter(contact => contact.id !== action.payload.deletedContactId)
    return state
  case Types.REMOVE_CONTACT_FROM_COMPANY:
    const company = state.paginationProgramCompanyList.find(c => c.id === action.payload.companyId)
    company.contacts = company.contacts.filter(contact => contact.id !== action.payload.contactId);
    return {
      ...state,
    }

  // case Types.SITE_CONTACT_LIST:
  //   return {
  //     ...state,
  //     siteContacts: action.data
  // }

    /* Program Packing List Reducers */
    case Types.PROGRAM_PACKING_LIST_SUCCESS:
      return {
        ...state,
        programPackingList: action.programPackingList
      }

    case Types.GET_ALL_PROGRAM_PACKING_LIST_SUCCESS:
      return {
        ...state,
        allProgramPackingList: action.allProgramPackingList
      }

    case Types.PROGRAM_PACKING_LIST_COUNT:
      return Object.assign({}, state, { programPackingListCount: action.programPackingListCount })

    case Types.PROGRAM_PACKING_LIST_ERROR:
      return {
        ...state,
        programPackingListError: action.programPackingListError
      }
    case Types.ADD_PROGRAM_PACKING_LIST_DATA:
      state.programPackingList.push(action.addProgramPackingListData)
      return { ...state };

    case Types.DELETE_PROGRAM_PACKING_LIST:
      return { ...state };
    
    case Types.PROGRAM_IP_WHITELIST_ROUTES: {
      return {
        ...state,
        programIPWhitelistRoutes: action.data
      }
    }
  }
};


